import React from 'react'

import FunIcon1 from '../../assets/images/funfacts/fun-icon1.png'
import FunIcon2 from '../../assets/images/funfacts/fun-icon2.png'
import FunIcon3 from '../../assets/images/funfacts/fun-icon3.png'

const Values = () => {
  const features = [
    { title: '算薪算税流程一体化', desc: '省时、省力、高效管理，节省人力', icon: FunIcon1 },
    { title: '定薪、调薪批量化', desc: '适应业务需求，提升人力核算效能', icon: FunIcon2 },
    { title: '复杂核算智能化', desc: '系统适应管理需求，核算灵活可调', icon: FunIcon3 },
  ]
  return (
    <div className="funfacts-area bg-image pt-100 pb-70">
      <div className="container">
        <div className="row">
          {features.map(({ title, desc, icon }, index) => (
            <div className="col-lg-4 col-sm-4 col-6 col-md-4" key={title}>
              <div className="single-funfacts-item">
                <div className="icon">
                  <img src={icon} alt="FunIcon" />
                </div>
                <h4 className="text-white">{title}</h4>
                <p>{desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Values
